module.exports = "/_next/static/images/92764862cb6ff13f1c81aa7adb7b118f-nubank-indoor-pool@md-2x.jpg.webp";